import React from 'react'
import PropTypes from 'prop-types'

import PageTitle from '../controls/PageTitle'
import LoadingStatus from '../controls/LoadingStatusContainer'
import OrganizationUsersContainer from './OrganizationUsersContainer'

class OrganizationUsersPage extends React.Component {
  static propTypes = {
    match: PropTypes.object.isRequired,
  }

  render() {
    return (
      <div>
        <PageTitle title="Users" />
        <LoadingStatus />
        <OrganizationUsersContainer organizationId={this.props.match.params.organizationId} />
      </div>
    )
  }
}

export default OrganizationUsersPage
